<template>
  <stage-card
    :progress="progress"
    progress-pending-label="Awaiting Import"
  >
    <template #header>Title &amp; Abstract Screening</template>
    <template #content>
      <screening-progress-and-results :review="review" />
      <div>
        <insights-info-list :review="review" />
      </div>
      <div>
        <screening-remaining-tasks-list
          :progress-summary="review.screeningProgressSummary"
        />
      </div>
    </template>
    <template #actions>
      <action-button
        text
        class="mr-3"
        color="primary"
        @click="openScreeningInsights"
      >
        View Insights
      </action-button>
      <stop-screening-button
        v-if="showStopScreeningButton"
        class="mr-3"
        :review="review"
        :current-researcher="currentResearcher"
      />
      <action-button color="primary" @click="$emit('open-workflow')">
        {{ openWorkflowLabel }}
      </action-button>
    </template>
  </stage-card>
</template>

<script>
import ActionButton from '@/components/Common/ActionButton';
import StageCard from './StageCard';
import ScreeningProgressAndResults from './ScreeningProgressAndResults';
import InsightsInfoList from './InsightsInfoList';
import ScreeningRemainingTasksList from './ScreeningRemainingTasksList';
import StopScreeningButton from '@/components/ScreeningPageV2/Common/StopScreeningButton';
import { GetCurrentResearcher } from '@/graphql';
import { Review, Researcher } from '@/models';
import { StageCardProgress } from '@/enums';

export default {
  name: 'ScreeningStageCard',
  components: {
    ActionButton,
    StageCard,
    ScreeningProgressAndResults,
    InsightsInfoList,
    ScreeningRemainingTasksList,
    StopScreeningButton,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
  },
  emits: ['open-workflow'],
  data: () => ({
    currentResearcher: null,
  }),
  apollo: {
    currentResearcher: {
      query: GetCurrentResearcher,
      update: (data) => new Researcher(data.currentResearcher),
    },
  },
  computed: {
    progress() {
      if (this.review.isScreeningComplete()) {
        return StageCardProgress.COMPLETE;
      }
      if (this.review.totalReferences() === 0) {
        return StageCardProgress.PENDING;
      }
      return StageCardProgress.IN_PROGRESS;
    },
    openWorkflowLabel() {
      if (this.review.isScreeningComplete()) {
        return 'View Outcomes';
      }
      return 'Screen References';
    },
    showStopScreeningButton() {
      return (
        this.currentResearcher &&
        this.allowExcludeRemaining &&
        !this.review.isScreeningComplete()
      );
    },
    allowExcludeRemaining() {
      if (!this.currentResearcher) return false;
      return this.review.researcherIsAdmin(this.currentResearcher);
    },
  },
  methods: {
    openScreeningInsights() {
      this.$router.push(`/review/${this.review.id}/screening`);
    },
  },
};
</script>
